import type React from 'react';

import type { InputProps } from '@material-ui/core/Input';

import { DefaultInput } from '../DefaultInput';

export interface NumberInputProps extends InputProps {
  precision?: number;
  onNumberChange?: (value?: number) => void;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
export const NumberInput: React.FC<NumberInputProps> = ({ value, precision = 0, onNumberChange, ...props }) => {
  const numberFormatter = new Intl.NumberFormat('pt-BR', {
    style: 'decimal',
    minimumFractionDigits: precision,
  });

  // @ts-ignore
  const fomattedValue = value ? numberFormatter.format(value) : '';

  const handleValueKeyDown = (event: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    if ([37, 38, 39, 40].includes(event.keyCode)) {
      event.preventDefault();
    }
  };

  const handleValueChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    const actualValue = event.target.value;

    const match = /[\D]*([\d., ]+).*[\D]*/.exec(actualValue);
    const valueRaw = match ? Number.parseFloat(match[1].replace(/[,. ]/g, '') || '0') : 0;
    const newValueRaw = precision > 0 ? valueRaw / 10 ** precision : valueRaw;

    if (onNumberChange) {
      onNumberChange(newValueRaw === 0 ? undefined : newValueRaw);
    }
  };

  return <DefaultInput onChange={handleValueChange} {...props} type='text' value={fomattedValue} onKeyDown={handleValueKeyDown} />;
};
